<script lang="ts" setup>
defineProps<{
  to: any;
}>();
</script>
<template>
  <dt class="property-row-description">
    <router-link v-if="to" :to="to">
      <slot />
    </router-link>
    <slot v-else></slot>
  </dt>
</template>
